/* Two-step size picker for pants and skirts (waist first, then length).
   Works on top of the theme's own Size radios: a length button clicks the matching radio. */
(function () {
  'use strict';
  if (window.__swuWl) return;
  window.__swuWl = true;

  var PICK_TEXT = 'Choose waist and length';
  var lastPicked = null;

  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function part(v, i) { return String(v).split('/')[i]; }
  function strings() { return window.variantStrings || {}; }

  function nativeRadios(w) {
    var vs = w.closest('variant-selects');
    return vs ? all(vs, '.swu-wl-native input[type="radio"]') : [];
  }
  function checkedRadio(w) {
    var r = nativeRadios(w).filter(function (x) { return x.checked; });
    return r.length ? r[0] : null;
  }
  function submitButton(pi) { return pi ? pi.querySelector('product-form [type="submit"]') : null; }

  function setButton(pi, disabled, text) {
    var b = submitButton(pi);
    if (!b) return;
    if (disabled) b.setAttribute('disabled', 'disabled'); else b.removeAttribute('disabled');
    var s = b.querySelector('span');
    if (s && text) s.textContent = text;
  }

  /* Nothing chosen yet (or the waist was changed): block adding to cart until a length is picked. */
  function enterPending(w) {
    var pi = w.closest('product-info');
    w.setAttribute('data-pending', '');
    if (!pi) return;
    pi.setAttribute('data-swu-wl-pending', '');
    all(pi, 'input[name="id"]').forEach(function (i) {
      if (i.value) i.setAttribute('data-swu-vid', i.value);
      i.value = '';
    });
    setButton(pi, true, PICK_TEXT);
  }

  function leavePendingKeepingVariant(w, soldOut) {
    var pi = w.closest('product-info');
    w.removeAttribute('data-pending');
    if (!pi) return;
    pi.removeAttribute('data-swu-wl-pending');
    all(pi, 'input[name="id"]').forEach(function (i) {
      var v = i.getAttribute('data-swu-vid');
      if (v && !i.value) i.value = v;
      i.removeAttribute('data-swu-vid');
    });
    if (soldOut) setButton(pi, true, strings().soldOut);
    else setButton(pi, false, strings().addToCart);
  }

  function updateSummary(w) {
    var m = w.querySelector('[data-swu-sum]');
    if (!m) return;
    var l = w.querySelector('[data-swu-length][aria-pressed="true"]');
    var waist = w.getAttribute('data-waist');
    m.textContent = l && waist ? 'Waist ' + waist + ' · Length ' + part(l.getAttribute('data-swu-length'), 0) : '';
  }

  function pickWaist(w, waist) {
    all(w, '[data-swu-waist]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-swu-waist') === waist));
    });
    all(w, '[data-swu-lengths]').forEach(function (g) {
      g.hidden = g.getAttribute('data-swu-lengths') !== waist;
    });
    w.setAttribute('data-waist', waist);

    var current = checkedRadio(w);
    var currentWaist = current ? part(current.value, 1) : null;
    if (!w.hasAttribute('data-pending') && currentWaist !== waist) {
      all(w, '[data-swu-length][aria-pressed="true"]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      enterPending(w);
    }
    updateSummary(w);
  }

  function pickLength(w, value) {
    var radio = nativeRadios(w).filter(function (r) { return r.value === value; })[0];
    if (!radio) return;
    var btn = all(w, '[data-swu-length]').filter(function (b) { return b.getAttribute('data-swu-length') === value; })[0];
    all(w, '[data-swu-length]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
    w.setAttribute('data-waist', part(value, 1));
    lastPicked = value;
    if (radio.checked) {
      /* Same size the theme already has selected: no change event will fire, so finish here. */
      if (w.hasAttribute('data-pending')) leavePendingKeepingVariant(w, btn && btn.classList.contains('is-soldout'));
    } else {
      /* The theme takes over: it swaps price, stock, button and URL, then tells us when it is done. */
      radio.click();
    }
    updateSummary(w);
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-swu-waist],[data-swu-length]') : null;
    if (!t) return;
    var w = t.closest('[data-swu-wl]');
    if (!w) return;
    if (t.hasAttribute('data-swu-waist')) pickWaist(w, t.getAttribute('data-swu-waist'));
    else pickLength(w, t.getAttribute('data-swu-length'));
  });

  /* Pickers that arrive already waiting for a choice (page load, quick add window). */
  function initPending() {
    all(document, '[data-swu-wl][data-pending]:not([data-swu-ready])').forEach(function (w) {
      w.setAttribute('data-swu-ready', '');
      enterPending(w);
    });
  }
  function boot() {
    initPending();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        all(document, 'product-info[data-swu-wl-pending]').forEach(function (pi) { pi.removeAttribute('data-swu-wl-pending'); });
        if (!lastPicked) return;
        var b = all(document, '[data-swu-length]').filter(function (x) {
          return x.getAttribute('data-swu-length') === lastPicked && x.getAttribute('aria-pressed') === 'true';
        })[0];
        if (b) b.focus({ preventScroll: true });
        lastPicked = null;
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  new MutationObserver(function () {
    if (document.querySelector('[data-swu-wl][data-pending]:not([data-swu-ready])')) initPending();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
